import(/* webpackMode: "eager", webpackExports: ["BackButton"] */ "/app/apps/pickleball/src/components/Error/back-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AxeptioScript"] */ "/app/apps/pickleball/src/components/RenderScripts/AxeptioScript.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TopNavigationWrapper"] */ "/app/apps/pickleball/src/modules/top-navigation/TopNavigationWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.4.5_@babel+core@7.28.4_@opentelemetry+api@1.9.0_react-dom@19.2.0_react@19.2.0__react@19.2.0_sass@1.78.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorPage"] */ "/app/packages/features/src/error-pages/error-page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AdvertisementWrapper"] */ "/app/packages/ui/src/components/advertisements/components/advertisement-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MainHeader"] */ "/app/packages/ui/src/components/global/Header/MainHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/src/components/global/platformStatsFooter/PlatformStatsFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/src/components/global/platformStatsFooter/PlatformStatsFooterSkeleton.tsx");
